import { BenutzerKompetenz, Schulform, ServerMode } from "@core";

import { RouteNode } from "~/router/RouteNode";

import { type RouteApp } from "~/router/apps/RouteApp";

import { RouteDataSchule } from "~/router/apps/schule/RouteDataSchule";
import { routeSchuleStammdaten } from "~/router/apps/schule/stammdaten/RouteSchuleStammdaten";
import { AppMenuGroup } from "@ui";

export class RouteSchule extends RouteNode<RouteDataSchule, RouteApp> {

	public constructor() {
		super(Schulform.values(),
			[BenutzerKompetenz.KEINE],
			"schule",
			"schule",
			undefined,
			new RouteDataSchule()
		);
		super.text = "Schule";
		super.mode = ServerMode.STABLE;
		super.menugroup = AppMenuGroup.MAIN;
		super.icon = "i-ri-school-line";
	}

	protected async update(to: RouteNode<any, any>) {
		if (to.name === this.name) {
			return routeSchuleStammdaten.getRoute();
		}
	}

}

export const routeSchule = new RouteSchule();
